import {
  Component,
  OnInit,
  Input,
  OnChanges,
  SimpleChanges,
} from "@angular/core";
import { AppService } from "src/app/app.service";
import { Dictionary } from "src/app/store/models/common_types";
import { freshnessPeriod } from "../qc-dashboard.model";

@Component({
  selector: "app-freshness-chart",
  templateUrl: "./freshness-chart.component.html",
  styleUrls: ["./freshness-chart.component.scss"],
  host: { class: "freshness-chart-component" },
})
export class FreshnessChartComponent implements OnInit, OnChanges {
  @Input() ticker;
  chartType: string;
  chartDataToUse: Dictionary<any>;
  isDataLoaded = false;
  period = false;
  averageAge: number;
  sinceLastUpdate: number;
  sinceRecentUpdate: number;

  constructor(private appService: AppService) {}

  ngOnInit() {
    this.chartType = "freshness-chart";
    this.chartDataToUse = {
      ticker: this.ticker,
      period: freshnessPeriod["120_days"],
      allPeriodsEnum: freshnessPeriod,
    };
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.ticker.previousValue !== this.ticker) {
      this.chartDataToUse = {
        ...this.chartDataToUse,
        ticker: this.ticker,
      };
    }
  }

  setCardData(data) {
    this.isDataLoaded = true;
    this.averageAge = data.tableData.averageAge;
    this.sinceLastUpdate = data.tableData.sinceLastUpdate;
    this.sinceRecentUpdate = data.tableData.sinceRecentUpdate;
  }

  setFreshnessPeriod() {
    //log user action here TOGGLE_FRESHNESSFREQ,ANALYSTDASH_PAGE
    const extras = {
      UTCTIME: new Date().toUTCString(),
      URL: location.href,
      VALUE: "ANALYSTDASH_PAGE",
    };

    this.appService.logUserAction(
      {},
      "",
      "",
      "TOGGLE_FRESHNESSFREQ",
      extras,
      "",
      "",
    );
    let period = freshnessPeriod["120_days"];
    if (this.period) {
      period = freshnessPeriod["1_year"];
    } else {
      period = freshnessPeriod["120_days"];
    }
    this.chartDataToUse = {
      ...this.chartDataToUse,
      period,
    };
  }
}
